import { defineComponent as $, useSlots as F, useAttrs as E, ref as v, onMounted as x, onUpdated as U, watch as M, nextTick as P, computed as g, openBlock as i, createBlock as l, Transition as j, withCtx as u, createElementBlock as c, mergeProps as G, unref as o, createElementVNode as m, normalizeClass as J, createVNode as S, renderSlot as y, createCommentVNode as t, toDisplayString as s, createTextVNode as h } from "vue";
import A from "./novoui-vuejs2.js";
import "./novoui-vuejs3.js";
import "./novoui-vuejs4.js";
import "./novoui-vuejs5.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs79.js";
import "./novoui-vuejs80.js";
import "./novoui-vuejs9.js";
import k from "./novoui-vuejs10.js";
import "./novoui-vuejs41.js";
import "./novoui-vuejs12.js";
import "./novoui-vuejs13.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import w from "./novoui-vuejs18.js";
import "./novoui-vuejs19.js";
import "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs22.js";
import "./novoui-vuejs23.js";
import "./novoui-vuejs25.js";
import K from "./novoui-vuejs26.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs28.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs110.js";
import "./novoui-vuejs39.js";
import "./novoui-vuejs40.js";
import { EDialogSizes as p } from "./novoui-vuejs45.js";
import { useFocusTrap as O } from "./novoui-vuejs801.js";
const Q = {
  key: 0,
  class: "dialog-header-icon"
}, R = {
  key: 1,
  class: "dialog-headline dialog-headline-placement"
}, W = {
  key: 2,
  class: "dialog-subheadline"
}, X = { class: "dialog-body" }, Ne = /* @__PURE__ */ $({
  inheritAttrs: !1,
  __name: "NDialog",
  props: {
    /**
     * The size of the dialog
     */
    size: {
      type: String,
      required: !1,
      defaultValue: p.medium
    },
    /**
     * Determines whether the dialog may be dismissed by clicking the background
     */
    backgroundClose: {
      type: Boolean,
      required: !1,
      defaultValue: !1
    },
    /**
     * Headline shown in the header section (gets replaced by header slot)
     */
    headline: {
      type: String,
      defaultValue: "",
      required: !1
    },
    /**
     * Single paragraph shown in the header section (gets replaced by header slot)
     */
    subHeadline: {
      type: String,
      defaultValue: "",
      required: !1
    },
    /**
     * Icon shown in the header section (gets replaced by header slot)
     */
    headerIcon: {
      type: String,
      defaultValue: void 0,
      required: !1
    },
    /**
     * Displays dividers between sections if `true`
     */
    showDividers: {
      type: Boolean,
      defaultValue: !1,
      required: !1
    },
    /**
     * Aligns all the items (if supplied) in the header of the dialog (headline, subHeadline, icon) in the middle of the dialog
     */
    centerAlignHeader: {
      type: Boolean,
      defaultValue: !1,
      required: !1
    },
    /**
     * Method for the primary button (if none provided, button won't be displayed; gets replaced by footer slot)
     */
    primaryAction: {
      type: Function,
      defaultValue: void 0,
      required: !1
    },
    /**
     * Label for the primary action button (fill one, right-most)
     */
    primaryLabel: {
      type: String,
      defaultValue: "",
      required: !1
    },
    /**
     * Method for the primary button (if none provided, button won't be displayed; gets replaced by footer slot)
     */
    secondaryAction: {
      type: Function,
      required: !1,
      defaultValue: void 0
    },
    /**
     * Label for the secondary action button (outline-subtle one)
     */
    secondaryLabel: {
      type: String,
      defaultValue: "",
      required: !1
    },
    /**
     * Displays a checkbox that determines whether this dialog should be displayed again or not (gets replaced by footer slot)
     */
    dontShowAgainId: {
      type: String,
      required: !1,
      defaultValue: ""
    },
    /**
     * Label for the "Don't show this again" checkbox
     */
    dontShowAgainLabel: {
      type: String,
      required: !1,
      defaultValue: "Don't show this again"
    },
    /**
     * Shows or hides the dialog
     */
    isVisible: {
      type: Boolean,
      required: !1,
      defaultValue: !1
    },
    /**
     * Toggle autofocus inside the dialog component, for when it's shown; it will focus the first interactive element, otherwise it looks at any tabindex provided
     */
    autofocus: {
      type: Boolean,
      required: !1,
      defaultValue: !1
    }
  },
  emits: ["update:close", "update:dont-show", "update:open"],
  setup(b, { emit: V }) {
    const r = V, f = F(), { class: _, ...L } = E(), e = b, d = v(), n = v(), { activate: q, deactivate: C } = O(n, { immediate: !0, initialFocus: e.autofocus ? void 0 : !1 });
    x(() => {
      d.value = e.isVisible;
    }), U(() => {
      d.value = e.isVisible;
    }), M(d, async (a, N) => {
      d.value ? r("update:open") : r("update:close"), await P(), n.value && n.value.focus(), a ? q() : C();
    });
    const I = g(() => {
      switch (e.size) {
        case p.small:
          return "dialog-small";
        case p.large:
          return "dialog-large";
        case p.medium:
        default:
          return "dialog-medium";
      }
    }), B = g(
      () => e.showDividers && // is there a header?
      (e.headline && e.headline.trim() || e.subHeadline && e.subHeadline.trim() || e.headerIcon) && // is there a body?
      (f.default || // is there a footer?
      e.primaryAction && e.primaryLabel && e.primaryLabel.trim() || e.secondaryAction && e.secondaryLabel && e.secondaryLabel.trim() || e.dontShowAgainId && e.dontShowAgainId.trim())
    ), H = g(
      () => e.showDividers && // is there a body?
      f.default && // is there a footer?
      (e.primaryAction && e.primaryLabel && e.primaryLabel.trim() || e.secondaryAction && e.secondaryLabel && e.secondaryLabel.trim() || e.dontShowAgainId && e.dontShowAgainId.trim())
    );
    function z(a) {
      r("update:close", a);
    }
    function D(a) {
      e.backgroundClose && r("update:close", a);
    }
    function T(a) {
      e.dontShowAgainId && r("update:dont-show", a, e.dontShowAgainId);
    }
    return (a, N) => (i(), l(j, {
      "enter-from-class": "dialog-enter-from",
      "enter-active-class": "dialog-enter-active",
      "leave-to-class": "dialog-leave-to",
      "leave-active-class": "dialog-leave-active"
    }, {
      default: u(() => [
        d.value ? (i(), c("div", G({
          key: 0,
          ref_key: "focusTrapTarget",
          ref: n,
          class: ["dialog-container", o(_)]
        }, L), [
          m("div", {
            class: "dialog-background",
            onClick: D
          }),
          m("div", {
            class: J(["dialog", [
              I.value,
              {
                "dialog-no-subheadline": !(e.subHeadline && e.subHeadline.trim()),
                "dialog-header-center": e.centerAlignHeader,
                "dialog-header-slot": o(f)["dialog-header"]
              }
            ]])
          }, [
            m("button", {
              class: "dialog-close",
              "aria-label": "Close dialog",
              "data-testid": "dialog-close",
              onClick: z
            }, [
              S(o(k), {
                icon: "close",
                size: "small",
                class: "dialog-close-icon"
              })
            ]),
            y(a.$slots, "dialog-header", {}, () => [
              e.headerIcon ? (i(), c("div", Q, [
                S(o(k), {
                  icon: e.headerIcon,
                  size: "normal"
                }, null, 8, ["icon"])
              ])) : t("", !0),
              e.headline && e.headline.trim() ? (i(), c("h4", R, s(e.headline), 1)) : t("", !0),
              e.subHeadline && e.subHeadline.trim() ? (i(), c("p", W, s(e.subHeadline), 1)) : t("", !0)
            ]),
            B.value ? (i(), l(o(w), {
              key: 0,
              class: "dialog-divider"
            })) : t("", !0),
            m("div", X, [
              y(a.$slots, "default")
            ]),
            H.value ? (i(), l(o(w), {
              key: 1,
              class: "dialog-divider-2"
            })) : t("", !0),
            y(a.$slots, "dialog-footer", {}, () => [
              e.primaryAction && e.primaryLabel && e.primaryLabel.trim() ? (i(), l(o(A), {
                key: 0,
                variant: "fill",
                class: "dialog-primary-action",
                onClick: e.primaryAction,
                size: "small"
              }, {
                default: u(() => [
                  h(s(e.primaryLabel), 1)
                ]),
                _: 1
              }, 8, ["onClick"])) : t("", !0),
              e.secondaryAction && e.secondaryLabel && e.secondaryLabel.trim() ? (i(), l(o(A), {
                key: 1,
                variant: "outlineSubtle",
                class: "dialog-secondary-action",
                onClick: e.secondaryAction,
                size: "small"
              }, {
                default: u(() => [
                  h(s(e.secondaryLabel), 1)
                ]),
                _: 1
              }, 8, ["onClick"])) : t("", !0),
              e.dontShowAgainId && e.dontShowAgainId.trim() ? (i(), l(o(K), {
                key: 2,
                class: "dialog-tertiary-action",
                value: `do_not_reopen_${b.dontShowAgainId}`,
                "onUpdate:modelValue": T
              }, {
                default: u(() => [
                  h(s(e.dontShowAgainLabel), 1)
                ]),
                _: 1
              }, 8, ["value"])) : t("", !0)
            ])
          ], 2)
        ], 16)) : t("", !0)
      ]),
      _: 3
    }));
  }
});
export {
  Ne as default
};
